
const TUTORIAL_VIDEOS = {
/*   "/user/dashboard": "/videos/Spider.mkv",
  "/user/plans": "/videos/hamsafar.mp4",  */
};

export const DEFAULT_TUTORIAL_VIDEO = "";


export function getTutorialVideo(pathname) {
  const matchedKey = Object.keys(TUTORIAL_VIDEOS)
    .filter((key) => pathname.includes(key))
    .sort((a, b) => b.length - a.length)[0];

  return matchedKey ? TUTORIAL_VIDEOS[matchedKey] : DEFAULT_TUTORIAL_VIDEO;
}

export default TUTORIAL_VIDEOS;